import { AxiosResponse } from 'axios';
import AxiosInstanceYalo from './AxiosInstanceYalo';
import { Notification } from './types';

export const getLastContactNotification = async (id: string): Promise<AxiosResponse<Notification>> =>
  AxiosInstanceYalo.get(`v1/contact/${id}/notification/latest`);
